import { Fab } from '@mui/material';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';

function MenuAcciones({ handlerAccion }) {
    return (
        <div>
            <Fab size="small" color="primary" aria-label="add" onClick= {() => handlerAccion("a")}>
                <AddIcon />
            </Fab>
{/*             <Fab size="small" color="secondary" aria-label="edit" onClick= {() => handlerAccion("m")}>
                <EditIcon />
            </Fab>     */}        
        </div>
    );
}

export default MenuAcciones;